import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            hidden: true,
            redirect: '/complaint',
            meta: { title: '首页', icon: './static/images/home.png' }
        },
        {
            path: '/login',
            name: 'login',
            hidden: true,
            component: () => import('@/views/login'),
            meta: { title: '登录' }
        },
        {
            path: '/regist',
            name: 'Regist',
            hidden: true,
            component: () => import('@/views/regist'),
            meta: { title: '注册' }
        },
        {
            path: '/complaint',
            name: 'Complaint',
            hidden: false,
            component: () => import('@/views/default'),
            redirect: '/complaint/default',
            meta: { title: '我要投诉', icon: '' },
            children: [
                {
                    path: 'default',
                    name: 'ComplaintDefault',
                    hidden: true,
                    component: () => import('@/views/complaint/notice'),
                    meta: { title: '我要投诉', icon: '' }
                },
                {
                    path: 'select',
                    name: 'EnterpriseSelect',
                    hidden: true,
                    component: () => import('@/views/complaint/enterpriseSelect'),
                    meta: { title: '我要企业类型选择', icon: '' }
                },
                {
                    path: 'info',
                    name: 'ComplaintInfo',
                    hidden: true,
                    component: () => import('@/views/complaint/complaint'),
                    meta: { title: '投诉信息', icon: '' }
                },
                {
                    path: 'complaintInter',
                    name: 'ComplaintInter',
                    hidden: true,
                    component: () => import('@/views/simpleComplaint/complainInter'),
                    meta: { title: 'App投诉', icon: '' }
                },
                {
                    path: 'transferNetWorkwn',
                    name: 'TransferNetWorkwn',
                    hidden: true,
                    component: () => import('@/views/simpleComplaint/transferNetWorkwn'),
                    meta: { title: '携号转网', icon: '' }
                },
                {
                    path: 'success',
                    name: 'Success',
                    hidden: true,
                    component: () => import('@/views/simpleComplaint/success'),
                    meta: { title: '投诉成功', icon: '' }
                }
            ]
        },
        {
            path: '/search',
            name: 'Search',
            hidden: false,
            component: () => import('@/views/appraise/notLoginPage'),
            meta: { title: '查询评价', icon: '', login: false }
        },
        {
            path: '/search/myComplaints',
            name: 'SearchMyComplaints',
            hidden: false,
            component: () => import('@/views/appraise/myComplaint'),
            meta: { title: '我的投诉', icon: '', login: false }
        },
        {
            path: '/search/myComplaints/detail',
            name: 'myComplaintDetail',
            hidden: false,
            component: () => import('@/views/appraise/detail'),
            meta: { title: '我的投诉详情', icon: '', login: false }
        },
        {
            path: '/search/myAccount',
            name: 'account',
            component: () => import('@/views/appraise/myAccount'),
            hidden: false,
            meta: { title: '我的信息', icon: '' }
        },
        {
            path: '/enterpriseServiceChannel',
            name: 'Enterprise',
            hidden: false,
            redirect: '/enterpriseServiceChannel/list',
            component: () => import('@/views/default'),
            meta: { title: '企业信息', icon: '' },
            children: [
                {
                    path: 'list',
                    name: 'EnterpriseList',
                    hidden: true,
                    component: () => import('@/views/enterprise/list'),
                    meta: { title: '列表', icon: '' }
                },
                {
                    path: 'detail',
                    name: 'EnterpriseDetail',
                    hidden: true,
                    component: () => import('@/views/enterprise/detail'),
                    meta: { title: '详情', icon: '' }
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js